package com.bikompanion.ui.composables

import androidx.compose.animation.AnimatedContent
import androidx.compose.animation.core.tween
import androidx.compose.animation.fadeIn
import androidx.compose.animation.fadeOut
import androidx.compose.animation.togetherWith
import androidx.compose.material3.LocalTextStyle
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.TextStyle
import androidx.compose.ui.tooling.preview.Preview
import com.bikompanion.ui.preview.PreviewSurface

/**
 * A [Text] that crossfades when [text] changes, and animates its own size if the new text wraps
 * differently. The old text leaves quickly and the new one arrives a beat later, so the two never
 * overlap into an unreadable smear while a sheet swaps from one station to the next.
 */
@Composable
internal fun AnimatedText(
    text: String,
    modifier: Modifier = Modifier,
    style: TextStyle = LocalTextStyle.current,
    color: Color = Color.Unspecified,
) {
    AnimatedContent(
        targetState = text,
        modifier = modifier,
        transitionSpec = {
            fadeIn(tween(durationMillis = 220, delayMillis = 90)) togetherWith fadeOut(tween(durationMillis = 90))
        },
        label = "AnimatedText",
    ) { value ->
        Text(
            text = value,
            style = style,
            color = color,
        )
    }
}

@Preview
@Composable
private fun AnimatedTextPreview() {
    PreviewSurface {
        AnimatedText(text = "Plaça Catalunya")
    }
}
